<template>
  <GenericHomeCard
    :shiftTypeId="survey.ShiftTypeId"
    :linkTo="{ name: 'survey', params: { survey_id: survey.Id} }"
    :mainTitle="'survey_questionnaire'"
    :subTitle="survey.Title"
    :content="survey.RoundName"
    :buttonCaption="$t('survey_enter_questions')"
  />
</template>

<script>
  import { mapGetters } from 'vuex'
  import GenericHomeCard from '../utilities/GenericHomeCard.vue'

  export default {
    props: ['survey'],
    components: {GenericHomeCard},
    computed: {
      ...mapGetters([
        'getShiftClass',
      ]),
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/surveys/Survey.vue